import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { AboutComponent } from './components/about/about.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ContactComponent } from './components/contact/contact.component';
import { FullLoginComponent } from './components/full-login/full-login.component';
import { FullRegisterComponent } from './components/full-register/full-register.component';
import { NoAuthGuard } from '../services/no-auth.guard';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { SendConfirmComponent } from './components/send-confirm/send-confirm.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'login',
    component: FullLoginComponent,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'register',
    component: FullRegisterComponent,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'send-confirm',
    component: SendConfirmComponent
  },
  //   {
  //       path: 'about',
  //       component: AboutComponent
  //   },
  {
    path: 'page-not-found',
    component: NotFoundComponent
  },
  {
    path: 'important-information',
    component: ContactComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule {}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/core/core.routing.ts